import {Answer} from 'Models'
import head from 'ramda/es/head'
import equals from 'ramda/es/equals'
import {calcSimplePoints} from '../_common/pointsCalculationHelper';

export const calculatePoints = answer => {
    const userInput         = answer.userInput()
    const expectedAnswers   = answer.correctAnswers() // = [{ "?":["x", "y"] }, ...]
    const question          = answer.question()
    const isCountPerAnswer  = question.countPerAnswer()
    const points            = () => Number(question.points())

    if(!userInput || userInput.length<1)
        return 0

    const answers       = head(userInput).value.answerData
    const results       = expectedAnswers.map( ea => head(answers[ea.gegeben]) === ea.erwartet )
    const correctOnes   = () => results.filter(equals(true)).length

    return  isCountPerAnswer ? correctOnes()*points() : calcSimplePoints(answer)
}